(function () {
  function initBestSellers() {
    var root = document.querySelector('[data-bestsellers]');
    if (!root || root.dataset.filtersReady) return;
    var controls = root.querySelector('[data-bestsellers-filters]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-bestsellers-model]'));
    if (!controls || !cards.length) return;
    root.dataset.filtersReady = 'true';
    var buttons = Array.prototype.slice.call(controls.querySelectorAll('button[data-category]'));
    var count = controls.querySelector('[data-bestsellers-count]');
    function applyFilter(category) {
      var seen = Object.create(null);
      var visible = 0;
      cards.forEach(function (card) {
        var matches = category === 'all' || card.dataset.bestsellersCategory === category;
        var model = card.dataset.bestsellersModel;
        card.hidden = !matches || !!seen[model];
        if (!card.hidden) { seen[model] = true; visible += 1; }
      });
      buttons.forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.category === category));
      });
      count.textContent = visible + ' דגמים · לפי סדר המכירות באתר';
    }
    buttons.forEach(function (button) {
      var category = button.dataset.category;
      button.hidden = category !== 'all' && !cards.some(function (card) {
        return card.dataset.bestsellersCategory === category;
      });
      button.addEventListener('click', function () { applyFilter(category); });
    });
    applyFilter('all');
    controls.hidden = false;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBestSellers);
  else initBestSellers();
  document.addEventListener('shopify:section:load', initBestSellers);
})();
